import { graphql, useStaticQuery } from 'gatsby'

export const useAppIcons = () => {
  const data = useStaticQuery(graphql`
    query AppIconImages {
      actionsIconImage: file(
        relativePath: { eq: "branding/actions_icon.webp" }
      ) {
        childImageSharp {
          ...standardImage
        }
      }
      timepageIconImage: file(
        relativePath: { eq: "branding/timepage_icon.webp" }
      ) {
        childImageSharp {
          ...standardImage
        }
      }
      flowIconImage: file(relativePath: { eq: "branding/flow_icon.webp" }) {
        childImageSharp {
          ...standardImage
        }
      }
      overlapIconImage: file(
        relativePath: { eq: "branding/overlap_icon.webp" }
      ) {
        childImageSharp {
          ...standardImage
        }
      }
      bundleIconImage: file(relativePath: { eq: "branding/bundle.png" }) {
        childImageSharp {
          ...standardImage
        }
      }
    }
  `)

  return data
}
